var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-announcement-content-wrapper"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))]),_c('p',{staticClass:"line"}),_c('div',{ref:"htmlbody",staticClass:"html-body",domProps:{"innerHTML":_vm._s(_vm.htmlText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }